import React, { lazy, Suspense } from 'react';

const LazyDTRSuccess = lazy(async () => await import('./DTRSuccess'));

const DTRSuccess = (props: JSX.IntrinsicAttributes & { children?: React.ReactNode }) => (
  <Suspense fallback={null}>
    <LazyDTRSuccess {...props} />
  </Suspense>
);

export default DTRSuccess;
